import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { LeafElement } from "../leaf-element.js";
import "../../utilities/events.js";
const styles = '/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  display: block;\n}\n\n:host(:not([columns="1"])) ::slotted(li) {\n  margin-bottom: var(--leaf-spacing-16);\n}\n:host(:not([columns="1"])) ::slotted(li:last-child) {\n  margin-bottom: 0;\n}\n\n.leaf-c-list--alternate,\n.leaf-c-list--dark {\n  border-radius: var(--leaf-border-radius-large);\n  padding: var(--leaf-spacing-32);\n}\n@media (min-width: 48rem) {\n  .leaf-c-list--alternate,\n  .leaf-c-list--dark {\n    padding: var(--leaf-spacing-48);\n  }\n}\n\n.leaf-c-list--alternate {\n  background: var(--leaf-color-bg-subtle);\n}\n\n.leaf-c-list--dark {\n  background: var(--leaf-color-bg-brand-xstrong);\n  color: var(--leaf-color-content-knockout);\n}\n\n.leaf-c-list--inverted {\n  color: var(--leaf-color-content-knockout);\n}\n\nul,\nol {\n  border: unset;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n\n.leaf-c-list--stacked ul,\n.leaf-c-list--stacked ol,\n.leaf-c-list--inline ul,\n.leaf-c-list--inline ol {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  gap: var(--leaf-spacing-16);\n}\n\n.leaf-c-list--multicolumn ul,\n.leaf-c-list--multicolumn ol {\n  -moz-column-count: 2;\n       column-count: 2;\n  display: block;\n}\n\n@media (min-width: 48rem) {\n  .leaf-c-list--inline ul,\n  .leaf-c-list--inline ol {\n    flex-direction: row;\n    gap: var(--leaf-spacing-24);\n  }\n}\n\n::slotted([slot=heading]) {\n  font-family: var(--leaf-typography-title-large-font-family) !important;\n  font-size: var(--leaf-typography-title-large-font-size) !important;\n  font-weight: var(--leaf-typography-title-large-font-weight) !important;\n  line-height: var(--leaf-typography-title-large-line-height) !important;\n  margin-bottom: var(--leaf-spacing-16) !important;\n}\n@media (min-width: 48rem) {\n  ::slotted([slot=heading]) {\n    font-family: var(--leaf-typography-title-xlarge-font-family) !important;\n    font-size: var(--leaf-typography-title-xlarge-font-size) !important;\n    font-weight: var(--leaf-typography-title-xlarge-font-weight) !important;\n    line-height: var(--leaf-typography-title-xlarge-line-height) !important;\n  }\n}\n\n::slotted([slot=content]) {\n  margin-bottom: var(--leaf-spacing-16) !important;\n}';
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
class LeafList extends LeafElement {
  constructor() {
    super(...arguments);
    this.variant = "transparent";
    this.ordered = false;
    this.inline = false;
    this.inverted = false;
    this.columns = 1;
  }
  renderList() {
    if (this.ordered) {
      return html`<ol part="list">
        <slot></slot>
      </ol>`;
    }
    return html`<ul part="list">
      <slot></slot>
    </ul>`;
  }
  render() {
    const componentClassName = {
      "leaf-c-list": true,
      "leaf-c-list--alternate": this.variant === "alternate",
      "leaf-c-list--dark": this.variant === "dark",
      "leaf-c-list--transparent": this.variant === "transparent",
      "leaf-c-list--inverted": this.inverted && this.variant === "transparent",
      "leaf-c-list--stacked": !this.inline && this.columns === 1,
      "leaf-c-list--inline": this.inline,
      "leaf-c-list--multicolumn": !this.inline && this.columns !== 1
    };
    return html`<div class=${classMap(componentClassName)} part="base">
      <slot part="heading" name="heading"></slot>
      <slot part="content" name="content"></slot>
      ${this.renderList()}
    </div>`;
  }
}
LeafList.styles = unsafeCSS(styles);
__decorateClass([
  property()
], LeafList.prototype, "variant", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], LeafList.prototype, "ordered", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], LeafList.prototype, "inline", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], LeafList.prototype, "inverted", 2);
__decorateClass([
  property({ type: Number, reflect: true })
], LeafList.prototype, "columns", 2);
export {
  LeafList
};
//# sourceMappingURL=list.component.js.map
